import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ThemeProvider } from '@mui/material/styles';
import pgmTheme from 'core/layouts/theme';
import parse from 'html-react-parser';

const ConfirmationDialog = ({ open, options, onCancel, onConfirm, onClose }) => {
  const {
    title,
    description,
    content,
    confirmationText="Confirm",
    cancellationText = "Canel",
    dialogProps,
    confirmationButtonProps,
    cancellationButtonProps,
    titleProps,
    contentProps,
    allowClose,
  } = options;

  return (
    <ThemeProvider theme={pgmTheme}>
      <Dialog fullWidth {...dialogProps} open={open} onClose={allowClose ? onClose : null}>
        {title && (
          <DialogTitle {...titleProps}>{title}</DialogTitle>
        )}
        {content ? (
          <DialogContent {...contentProps}>
            {parse(content)}
          </DialogContent>
        ) : (
          description && (
            <DialogContent {...contentProps}>
              <DialogContentText>{description}</DialogContentText>
            </DialogContent>
          )
        )}
        <DialogActions>
          <Button  {...cancellationButtonProps} color="error" onClick={onCancel}>
            {cancellationText}
          </Button>
          <Button  {...confirmationButtonProps} color="success" onClick={onConfirm}>
            {confirmationText}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ConfirmationDialog;
